__webpack_require__.p = "https://squll.fartcore.ai/";